import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=4ff28a8a&scoped=true&"
import script from "./MedicalRecord.vue?vue&type=script&lang=js&"
export * from "./MedicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=4ff28a8a&lang=scss&scoped=true&"
import style1 from "./MedicalRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff28a8a",
  null
  
)

export default component.exports